import React, { Component } from "react";
import "./assets/css/main.css";
import PageHeader from "./components/PageHeader";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import MainRoutes from "./routers/mainRouter";
import appMainStyle from "./assets/jss/appMainStyle";
import {
  withCookies
} from 'react-cookie'
import history from "./routers/history";

class App extends Component {
  constructor(props) {
    super(props);
    this.goToHomePage = this.goToHomePage.bind(this);
  }

  render() {
    const { classes } = this.props;
    
    return (
      <div className={classes.wrapper}>
        <div className={classes.mainPanel}>
          <PageHeader color="primary" goToHomePage={this.goToHomePage} />
          <div className={classes.content}>
            <MainRoutes cookies={this.props.cookies}/>
            {/* <MainRoutes/> */}
          </div>
        </div>
      </div>
    );
  }

  goToHomePage() {
    history.push("/");
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(appMainStyle)(withCookies(App));
